import babelpolyfill from 'babel-polyfill'

import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
//import 'element-ui/lib/theme-chalk/index.css';
import './assets/theme/theme-chalk/index.css'
//import './assets/theme/theme-navy/index.css'
import 'font-awesome/css/font-awesome.min.css'
import './styles/global.scss'
import router from './router'
import store from './store'
import Vuex from 'vuex'
import './permission' // permission control
import * as filters from './filters' // global filters

import { parseTime, formatTime } from '@/utils'
// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})




//注册全局时间转换函数
	Vue.prototype.dateFormat = function(row, column) {
		var date = row[column.property];
		if(date == undefined) {
			return "";
		}
		return parseTime(date);
	}








Vue.config.productionTip = false
Vue.use(ElementUI)

Vue.use(Vuex)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
